<!-- Dialog di conferma cancellazione documento -->
<h1 mat-dialog-title>{{ 'confirmDelete' | translate }}</h1>

<div mat-dialog-content>
  <!-- Messaggio di conferma -->
  <p class="confirmation-message">
    {{ 'confirmDeleteDocumentMessage' | translate }} 
    <strong>{{ data.documentName }}</strong>?
  </p>

  <!-- Checkbox per eliminazione dal file system -->
  <mat-checkbox 
    [(ngModel)]="deleteFromFileSystem" 
    color="warn"
    class="delete-filesystem-checkbox">
    {{ 'deleteFromFileSystem' | translate }}
  </mat-checkbox>

  <!-- Avviso per l'eliminazione permanente -->
  <p class="warning-message" *ngIf="deleteFromFileSystem">
    <mat-icon color="warn">warning</mat-icon>
    {{ 'permanentDeleteWarning' | translate }}
  </p>
</div>

<!-- Pulsanti di azione -->
<div mat-dialog-actions>
  <ct-button [configuration]="cancelButton"></ct-button>
  <ct-button [configuration]="deleteButton"></ct-button>
</div>
